module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('span', [_vm._v("您当前的地区:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "anhui"
    }
  }, [_vm._v("安徽")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fujian"
    }
  }, [_vm._v("福建")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "guangxi"
    }
  }, [_vm._v("广西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hunan"
    }
  }, [_vm._v("湖南")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "shanxi"
    }
  }, [_vm._v("陕西")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "guangdong"
    }
  }, [_vm._v("广东")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sichuan"
    }
  }, [_vm._v("四川")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yunnan"
    }
  }, [_vm._v("云南")])]), _vm._v(" "), _c('span', [_vm._v("[切换省份]")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": this.url
    }
  }, [_c('img', {
    attrs: {
      "src": this.topimg
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": this.bannerimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('h2', [_vm._v("下载游戏")]), _vm._v(" "), _c('div', {
    staticClass: "dwimg"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": this.dwimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "top",
    attrs: {
      "href": this.iosUrl
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('a', {
    staticClass: "bottom",
    attrs: {
      "href": this.url
    }
  }, [_c('img', {
    staticClass: "dw_right_bottom_img",
    attrs: {
      "src": require("../../images/xl_download_21.png")
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "attention"
  }, [_c('h2', [_vm._v("关注客服公众号")]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": this.dwimg
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t识别二维码关注我们的微信公众号，获得引导信息。\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "feature"
  }, [_c('h2', [_vm._v("游戏特色")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": this.img1
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": this.img2
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": this.img3
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": this.url
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/active/down_img_07.png")
    }
  }), _c('span', [_vm._v("立即下载")])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dw_right_top_img"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/xl_download_19.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dw_right_top_dow"
  }, [_c('span', {
    staticClass: "appstore"
  }, [_vm._v("App  Store")]), _c('span', [_vm._v("下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dw_right_bottom_dow"
  }, [_c('p', [_vm._v("安卓下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activefooter"
  }, [_c('div', {
    staticClass: "activelog"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../images/footer_nav_49.png"),
      "alt": "闲徕互娱"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2016 - 2017 京ICP备16022346号-4")]), _vm._v(" "), _c('p', [_vm._v("京网文[2016]1755-215号")]), _vm._v(" "), _c('p', [_vm._v("增值电信业务经营许可证 京B2-20170093 京公网备案")]), _vm._v(" "), _c('p', [_vm._v("公司名称：北京闲徕互娱网络科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("公司地址：北京市朝阳区天朗园C座3层03商业3-008")]), _vm._v(" "), _c('p', [_vm._v("公司电话：010-84935767")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fac03b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/active/Active.vue
// module id = 261
// module chunks = 1